export const NORMAL = 'Normal';
export const REGROUPEMENT = 'Regroupement';
export const CATEGORIE_DIVERS = 'Divers';
export const CATEGORIE_LOCATION = 'Location';
export const BLOQUE = 'Bloque';
export const OPTION = 'Option';
export const COMMENTAIRE = 'Commentaire';
export const MODE_CALCUL_MANUEL = 'Manuel';
export const FORFAIT_HONORAIRES_CATEGORIE = 'FORFAIT HONORAIRES';
export const HONORAIRES_CATEGORIE = 'honoraire';
export const ANNEE = 'Annee';
export const POURCENTAGE = 'Pourcentage';
export const TYPE_REMISE_CASCADE = 'Cascade';
export const SANS_SUITE = 'SansSuite';
